export default "__VITE_ASSET__zuLNbUg7__"